<template>
  <div class="transaction-table-item">
    <div class="transaction-table-item__short-info">
      <div
        class="transaction-table-item__open-btn"
        v-if="hasFullInfo"
        :class="{ toggled: isFullInfoOpened }"
        @click="toggleFullInfo"
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="25"
            height="25"
            rx="8.5"
            transform="matrix(0 1 1 0 0 0)"
            stroke="#E0E6F2"
          />
          <path
            d="M12.6491 15.5243L9.12646 12.0016C9.04492 11.9201 9 11.8114 9 11.6954C9 11.5794 9.04492 11.4706 9.12646 11.3892L9.38582 11.1297C9.55483 10.9609 9.8295 10.9609 9.99825 11.1297L12.9564 14.0879L15.9178 11.1265C15.9993 11.045 16.108 11 16.2239 11C16.34 11 16.4487 11.045 16.5303 11.1265L16.7896 11.3859C16.8711 11.4674 16.916 11.5761 16.916 11.6921C16.916 11.8081 16.8711 11.9168 16.7896 11.9983L13.2637 15.5243C13.1819 15.606 13.0727 15.6509 12.9566 15.6506C12.84 15.6509 12.7309 15.606 12.6491 15.5243Z"
            fill="#666D79"
          />
        </svg>
      </div>
      <slot
        name="shortInfo"
        :transaction="transaction"
        :hideActionsMenu="hideActionsMenu"
        :toggleActionsMenu="toggleActionsMenu"
        :actionsPending="actionsPending"
        :makeAction="makeAction"
        :isShowActionsMenu="isShowActionsMenu"
      ></slot>
    </div>
    <div class="transaction-table-item__full-info" v-if="isFullInfoOpened">
      <template v-if="transactionInner.fullInfoLoaded">
        <div class="transaction-table-item__full-info-wrapper">
          <template v-if="transactionInner.fullInfoLoaded">
            <transactions-table-accordion-helper
              v-for="detailItem in detailsItems"
              class="transaction-table-item__full-info-accordion"
              :title="$t(detailItem.title)"
              :key="`${detailItem.component}`"
            >
              <template v-slot:content>
                <component
                  :is="detailItem.component"
                  :transaction="transactionInner"
                  @parentOperationIdClicked="handleParentOperationIdClicked"
                ></component>
              </template>
            </transactions-table-accordion-helper>
          </template>
        </div>
        <div
          class="transaction-table-item__full-info-actions"
          v-if="fullInfoActions.length > 0"
        >
          <VDropdown
            trigger="hover"
            offset="4"
            placement="top"
            v-for="fullAction in fullInfoActions"
            :key="`full-action-id`"
          >
            <div
              class="transaction-table-item__full-info-actions-item"
              @click="fullAction.handler"
            >
              <div
                class="transaction-table-item__full-info-actions-item-icon"
                v-html="fullAction.icon"
              ></div>
            </div>
            <template v-slot:popover>
              <div class="bill-template__actions-item-hint">
                {{ fullAction.title }}
              </div>
            </template>
          </VDropdown>
        </div>
      </template>
      <template v-else>
        <div class="transaction-table-item__full-info-loader">
          <loader></loader>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { Transaction } from '@js-app/entities/transaction/Transaction'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import { mapState } from 'vuex'
import Loader from '@vue-app/components/base/Loader.vue'
import TransactionItemTransactionInfo from '@vue-app/components/company/transactions/table/info/TransactionItemTransactionInfo.vue'
import TransactionItemTransactionDetailsInfo from '@vue-app/components/company/transactions/table/info/TransactionItemTransactionDetailsInfo.vue'
import TransactionItemPaymentInfo from '@vue-app/components/company/transactions/table/info/TransactionItemPaymentInfo.vue'
import TransactionItemRegistryAttrInfo from '@vue-app/components/company/transactions/table/info/TransactionItemRegistryAttrInfo.vue'
import TransactionItemServiceItemInfo from '@vue-app/components/company/transactions/table/info/TransactionItemServiceItemInfo.vue'
import TransactionItemTicketInfo from '@vue-app/components/company/transactions/table/info/TransactionItemTicketInfo.vue'
import TransactionItemAccountPaymentsInfo from '@vue-app/components/company/transactions/table/info/TransactionItemAccountPaymentsInfo.vue'
import TransactionItemCryptocurrencyProjectInfo from '@vue-app/components/company/transactions/table/info/TransactionItemCryptocurrencyProjectInfo.vue'
import TransactionItemBillInfo from '@vue-app/components/company/transactions/table/info/TransactionItemBillInfo.vue'
import TransactionItemCardClientInfo from '@vue-app/components/company/transactions/table/info/TransactionItemCardClientInfo.vue'
import TransactionItemChargebackInfo from '@vue-app/components/company/transactions/table/info/TransactionItemChargebackInfo.vue'
import TransactionsTableAccordionHelper from '@vue-app/components/company/transactions/table/info/TransactionsTableAccordionHelper.vue'
import TransactionItemParentOperationInfo from '@vue-app/components/company/transactions/table/info/TransactionItemParentOperationInfo.vue'
export default {
  name: 'TransactionTableItem',
  props: {
    transaction: {
      type: [Transaction, Object],
    },
    detailsBlocks: {
      type: [Array, String],
      default: '*',
    },
    hasFullInfo: {
      type: Boolean,
      default: true,
    },
    fullInfoActions: {
      type: Array,
      default() {
        return []
      },
    },
  },
  components: {
    Loader,
    TransactionItemTransactionInfo,
    TransactionItemTransactionDetailsInfo,
    TransactionItemPaymentInfo,
    TransactionItemRegistryAttrInfo,
    TransactionItemServiceItemInfo,
    TransactionItemTicketInfo,
    TransactionItemAccountPaymentsInfo,
    TransactionItemCryptocurrencyProjectInfo,
    TransactionItemBillInfo,
    TransactionItemCardClientInfo,
    TransactionItemChargebackInfo,
    TransactionsTableAccordionHelper,
    TransactionItemParentOperationInfo
  },
  AVAILABLE_DETAILS_ITEMS: {
    TransactionItemTransactionInfo: {
      title: 'transaction-details.transaction-info.title',
      component: 'TransactionItemTransactionInfo',
    },

    TransactionItemCardClientInfo: {
      title: 'transaction-details.card-client-info.title',
      component: 'TransactionItemCardClientInfo',
    },
    TransactionItemTransactionDetailsInfo: {
      title: 'transaction-details.transaction-details-info.title',
      component: 'TransactionItemTransactionDetailsInfo',
    },
    TransactionItemPaymentInfo: {
      title: 'transaction-details.payment-info.title',
      component: 'TransactionItemPaymentInfo',
    },
    TransactionItemRegistryAttrInfo: {
      title: 'transaction-details.registry-attr-info.title',
      component: 'TransactionItemRegistryAttrInfo',
    },
    TransactionItemServiceItemInfo: {
      title: 'transaction-details.service-item-info.title',
      component: 'TransactionItemServiceItemInfo',
    },
    TransactionItemAccountPaymentsInfo: {
      title: 'transaction-details.account-payments-info.title',
      component: 'TransactionItemAccountPaymentsInfo',
    },
    TransactionItemTicketInfo: {
      title: 'transaction-details.ticket-info.title',
      component: 'TransactionItemTicketInfo',
    },
    TransactionItemCryptocurrencyProjectInfo: {
      title: 'transaction-details.cryptocurrency-project-info.title',
      component: 'TransactionItemCryptocurrencyProjectInfo',
    },
    TransactionItemBillInfo: {
      title: 'transaction-details.bill-info.title',
      component: 'TransactionItemBillInfo',
    },
    TransactionItemChargebackInfo: {
      title: 'transaction-details.chargeback-info.title',
      component: 'TransactionItemChargebackInfo',
    },
  },
  data() {
    return {
      isFullInfoOpened: false,
      isFullInfoLoading: false,
      isShowActionsMenu: false,
      actionsPending: [],
      transactionInner: new Transaction(),
    }
  },
  created() {
    this.transactionInner = this.transaction
  },
  computed: {
    ...mapState(['selectedCompany']),
    detailsItems() {
      let availableDetailsItems = { ...this.$options.AVAILABLE_DETAILS_ITEMS }

      if (this.transaction.transactionData.TransactionType === 'refund') {
        availableDetailsItems = {
          ...availableDetailsItems,
          TransactionItemParentOperationInfo: {
            title: 'transaction-details.parent-operation.title',
            component: 'TransactionItemParentOperationInfo',
          },
        }
      }

      if (Array.isArray(this.detailsBlocks)) {
        return this.detailsBlocks
          .filter((_dBlockName) =>
            Object.keys(availableDetailsItems).includes(_dBlockName)
          )
          .map((_dBlockName) => ({
            ...availableDetailsItems[_dBlockName],
          }))
      } else if (this.detailsBlocks === '*') {
        return Object.values(availableDetailsItems)
      }
    },
  },
  methods: {
    toggleFullInfo() {
      if (!this.isFullInfoOpened && !this.transaction.fullInfoLoaded) {
        this.loadFullInfo()
      }

      this.isFullInfoOpened = !this.isFullInfoOpened
    },
    async loadFullInfo() {
      if (!this.transaction.fullInfoLoaded && !this.isFullInfoLoading) {
        this.isFullInfoLoading = true
        const response = await CompaniesApi.getOperationDetails(
          this.selectedCompany,
          this.transaction.operationId
        )

        this.transactionInner.applyFullInfo(
          response.data.ReportOperations[0] || {}
        )
        $emit(this, 'fullInfoLoaded', this.transactionInner.transactionData)
        this.isFullInfoLoading = false
      }

      return {
        ...this.transactionInner.transactionData,
      }
    },
    toggleActionsMenu() {
      this.isShowActionsMenu = !this.isShowActionsMenu
    },
    hideActionsMenu() {
      this.isShowActionsMenu = false
    },
    makeAction(action) {
      if (this.actionsPending.includes(action.id)) {
        return
      }

      this.actionsPending.push(action.id)
      this.isShowActionsMenu = false

      $emit(this, 'actionFired', action)
    },
    actionFinished(actionName) {
      this.actionsPending.splice(
        this.actionsPending.findIndex((_a) => _a === actionName),
        1
      )
    },
    handleParentOperationIdClicked(parentOperationId) {
      $emit(this, 'parentOperationIdClicked', parentOperationId)
    },
  },
  emits: ['fullInfoLoaded', 'actionFired', 'parentOperationIdClicked'],
}
</script>

<style lang="scss" scoped>
.transaction-table-item {
  &__full-info {
    position: relative;
    &-actions {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 100%;
      background: #ffffff;
      padding: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      &-item {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f3f7fe;
        border-radius: 6px;
        cursor: pointer;

        &-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
